import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { setHeaderTitle } from "../../helpers/header.helper"
import { ChannelListActiveIcon, ChannelListIcon, ChannelStackActiveIcon, HubSpotIntcircleIcon, ChannelStackIcon, ClioIntcircleIcon, IntegrateAppsIcon, NewBadgeIcon, SlackIntCircleIcon, TeamsIntCircleIcon, TeamscircleSmallIcon, SlackCircleSmallIcon, HubspotCircleSmallIcon, ClioCircleSmallIcon, MicroSoftImportContacts, ImportOutlookIntigrationIcon, WebFormIntCircleIcon, WebFormCircleSmallIcon } from "../../icon"
import { AppRoutes } from "../routes/route.path"
import { IntegrationLabels, pageTitles } from "../shared/constants"
import { IntegrationSetupService } from "../../services/IntegrationSetup"
import { UserService } from "../../services/UserService"
import ButtonComponent from "../shared/button/button.component"
import { Grid, IconButton, Tooltip } from "@mui/material"
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';

type Props = {}

const Integrations = (props: Props) => {
	const navigate = useNavigate()
	const OrgId = UserService.getCurrentUserOrgId()
	const [integrationStatuses, setIntegrationStatuses] = useState([])
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [stackView, setStackView] = useState<boolean>(true)
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const IsDarkMode: boolean = useSelector(selector.isDarkMode)
	const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)

	useEffect(() => {
		setHeaderTitle(pageTitles.INTEGRATIIONS);
	}, [])

	const integrateOptions = [
		{
			id: 1,
			title: IntegrationLabels.MICROSOFT_TEAMS,
			code: IntegrationSetupService.MicrosoftTeams_Code,
			note: "Read and reply to Falkon SMS messages from Microsoft Teams",
			to: AppRoutes.TEAMS_CHANNEL_SETUP,
			staticViewIcon: <TeamsIntCircleIcon />,
			listViewIcon: <TeamscircleSmallIcon />,
			badgeIcon: <NewBadgeIcon />,
			Hide: IsTeamsApp ? true : false
		},
		{
			id: 2,
			title: IntegrationLabels.CLIO,
			code: IntegrationSetupService.ClioIntegration_Code,
			note: "Integrate Clio with Falkon SMS for seamless, real-time sync of contacts and conversations.",
			to: AppRoutes.CLIO,
			staticViewIcon: <ClioIntcircleIcon />,
			listViewIcon: <ClioCircleSmallIcon width={50} height={50} />,
			badgeIcon: <NewBadgeIcon />,
			Hide: false
		},
		{
			id: 3,
			title: IntegrationLabels.ACTIVITY_FEED,
			code: IntegrationSetupService.TeamsActivityFeed_Code,
			note: "Integrate Teams Activity Feed with Falkon SMS for Activity Feed Notifications in MS Teams.",
			to: AppRoutes.TEAMS_ACTIVITY_FEED,
			staticViewIcon: <TeamsIntCircleIcon />,
			listViewIcon: <TeamscircleSmallIcon />,
			badgeIcon: <NewBadgeIcon />,
			Hide: IsTeamsApp ? true : false
		},
		{
			id: 4,
			title: IntegrationLabels.HUBSPOT,
			code: IntegrationSetupService.HubSpotIntegration_Code,
			note: "Integrate HubSpot with Falkon SMS for seamless, real-time sync of contacts",
			to: AppRoutes.HUBSPOT,
			staticViewIcon: <HubSpotIntcircleIcon />,
			listViewIcon: <HubspotCircleSmallIcon />,
			badgeIcon: <NewBadgeIcon />,
			Hide: false
		},
		{
			id: 5,
			title: IntegrationLabels.SLACK,
			code: IntegrationSetupService.Slack,
			note: "Read and reply to Falkon SMS messages from Slack channels",
			to: AppRoutes.SLACK,
			staticViewIcon: <SlackIntCircleIcon />,
			listViewIcon: <SlackCircleSmallIcon width={30} height={30} />,
			badgeIcon: <NewBadgeIcon />,
			Hide: false
		},
		{
			id: 5,
			title: IntegrationLabels.OUTLOOK,
			code: IntegrationSetupService.OutlookIntigration_code,
			note: "Start Importing from Outlook to Falkon SMS",
			to: AppRoutes.OUTLOOK,
			staticViewIcon: <ImportOutlookIntigrationIcon />,
			listViewIcon: <MicroSoftImportContacts width={30} height={30} />,
			badgeIcon: <NewBadgeIcon />,
			Hide: false
		},
		{
			id: 6,
			title: IntegrationLabels.WEBFORM,
			code: IntegrationSetupService.WebForm,
			note: "Create and embed web forms for lead generation and contact collection.",
			to: AppRoutes.WEBFORM,
			staticViewIcon: <WebFormIntCircleIcon />,
			listViewIcon: <WebFormCircleSmallIcon width={30} height={30} />,
			badgeIcon: <NewBadgeIcon />,
			Hide: false
		}
	]

	useEffect(() => {
		setIsLoading(true)
		IntegrationSetupService.getAllIntegrations(OrgId).then(res => {
			setIsLoading(false)
			let status = res.data?.filter(x => integrateOptions.some(option => option.code === x.integrationCode)).map(x => ({ code: x.integrationCode, status: x.integrationStatus }));
			setIntegrationStatuses([...status, { code: IntegrationSetupService.WebForm, status: true }])
			IntegrationSetupService.ImportContactOutlookStatus().then((res) => {
				setIntegrationStatuses((prevstatus) => {
					const filteredStatus = prevstatus.filter(status => status.code !== "OUTLOOK");
					return [...filteredStatus, { code: "OUTLOOK", status: res.data.status }];
				});
			})
		})
	}, [])

	const getIntegrationStatus = (to, code) => {
		let status = integrationStatuses.find(x => x.code === code)?.status
		navigate(to + `?connection=${status === undefined ? false : status}`)
	}

	const openStack = () => {
		setStackView(true);
	}

	const openList = () => {
		setStackView(false);
	}

	return (
		<div className={`d-flex w-p-100 h-p-100 ${IsDarkMode ? "bg-color-primary-background" : "bg-color-profile-primary-background"}`}>
			<div className={`d-flex flex-direction w-fill h-fill m-2 ${IsDarkMode ? "bg-color-primary-background" : "bg-color-secondary"} br-3 integrate-card-border`}>
				<div className={`d-flex ${IsMobileDevice ? "flex-direction align-center h-v-22 pl-2" : "justify-between pl-6"} w-fill bg-color-integration-header brt-2 h-v-22`}>
					<div className={`d-flex ${IsMobileDevice ? "flex-direction text-center mt-4 mr-2 ml-1" : "flex-direction my-auto"}`}>
						<span className="h1-semibold color-secondary">Integrate Falkon SMS apps</span>
						<span className="h4-regular color-secondary">Supercharge your workflow and connect the tool you use every day.</span>
					</div>
					{!IsMobileDevice && <div className={`d-flex pr-15`}>
						<IntegrateAppsIcon />
					</div>}

				</div>
				<div className={`d-flex justify-between  ${IsMobileDevice ? "px-2" : "px-6"}`}>
					<div className="d-flex"></div>
					<div className="d-flex flex-direction-row my-1" style={{ gap: "0.5rem" }}>
						<div className="">
							{stackView ?
								<Tooltip title="Stack View" placement="bottom-start" className="">
									<IconButton onClick={openStack}>
										<ChannelStackActiveIcon />
									</IconButton>
								</Tooltip>
								:
								<Tooltip title="Stack View" placement="bottom-start" className="">
									<IconButton onClick={openStack}>
										<ChannelStackIcon />
									</IconButton>
								</Tooltip>
							}

						</div>
						<div className="">
							{stackView ?
								<Tooltip title="List View" placement="bottom-start" className="">
									<IconButton onClick={openList}>
										<ChannelListIcon />
									</IconButton>
								</Tooltip>
								:
								<Tooltip title="List View" placement="bottom-start" className="">
									<IconButton onClick={openList}>
										<ChannelListActiveIcon />
									</IconButton>
								</Tooltip>
							}
						</div>
					</div>
				</div>

				<div className={`d-flex  w-p-100 flex-wrap o-y-scroll ${IsDarkMode ? "bg-color-primary-background" : "bg-color-secondary"}`}>
					{stackView ?
						<Grid container className="w-p-95 d-flex mx-auto">
							{integrateOptions.filter(x => !x.Hide).map(x =>
								<Grid item md={5} lg={4} xl={3} className="d-flex">
									<div className={`m-1 integrate-card-box-shadow integrate-card-border w-p-100 br-3 py-2 ${IsMobileDevice ? "bg-color-intigration-card-bg" : ""}`}>
										<div className="d-flex justify-between w-p-92 mx-auto mb-2">
											<span className="p-relative">
												{x.staticViewIcon}
												<span className="p-absolute batch-icon">{x.badgeIcon}</span>
											</span>
											<span className="my-auto mr-2">
												<ButtonComponent
													Loading={isLoading}
													ButtonLabel={!isLoading ? integrationStatuses.find(status => status.code === x.code)?.status === true ? "Manage" : "Setup" : " "}
													Variant={integrationStatuses.find(status => status.code === x.code)?.status === true ? "channel-manage-button" : "secondary-btn"}
													OnClick={() => getIntegrationStatus(x.to, x.code)}
													ClassName="br-5"
												/>
											</span>
										</div>
										<div className="h3-medium h-6 d-flex align-center color-integration-card-title pb-1 w-p-92 mx-auto">{x.title}</div>
										<div className="h5-regular color-integration-card-note w-p-92 mx-auto">{x.note}</div>

									</div>
								</Grid>
							)}
						</Grid>
						:
						<div className="px-6 w-p-100">
							<div className="integrate-list-border">
								{integrateOptions.filter(x => !x.Hide).map(x =>
									<div key={x.id} className={`d-flex flex-direction max-h-25 px-2 integrate-card-list integrate-list-card-hover integrate-card-list-border`}>
										<div className={`d-flex justify-around align-center h-7`} style={{ gap: "2rem" }}>
											<div className="w-8 d-flex justify-center">
												<span className="p-relative">{x.listViewIcon}</span>
											</div>
											<div className="d-flex flex-direction w-fill my-auto">
												<div className="d-flex flex-direction-row" style={{ gap: "0.5rem" }}>
													<span className="h3-semibold color-integration-card-title">{x.title}</span>
													<div className="badge-container">{x.badgeIcon}</div>
												</div>
												<span className="h5-regular color-integration-card-note">{x.note}</span>
											</div>
											<div className="my-auto ">
												<ButtonComponent Loading={isLoading} ButtonLabel={!isLoading ? integrationStatuses.find(status => status.code === x.code)?.status === true ? "Manage" : "Setup" : " "} Variant={integrationStatuses.find(status => status.code === x.code)?.status === true ? "channel-manage-button" : "secondary-btn"} OnClick={() => getIntegrationStatus(x.to, x.code)}
													ClassName="br-5"
												/>
											</div>
										</div>
									</div>)}
							</div>
						</div>

					}

				</div>
			</div>
		</div>
	)
}

export default Integrations